import { render, staticRenderFns } from "./salesCommissionList.vue?vue&type=template&id=0a3c2c6c&scoped=true"
import script from "./salesCommissionList.vue?vue&type=script&lang=js"
export * from "./salesCommissionList.vue?vue&type=script&lang=js"
import style0 from "./salesCommissionList.vue?vue&type=style&index=0&id=0a3c2c6c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a3c2c6c",
  null
  
)

export default component.exports